import { listenToEvent } from '../util/listen_to_event.js';
import { window } from '../window.js';
import { LocSearchControl } from './locsearch_control.js';

/**
 * Location search control with a pick location button.
 */
class PickLocControl extends LocSearchControl {
  initialize() {
    super.initialize();

    this.rightButtonsElement.innerHTML = `
      <img class='autocomplete-button pick-button' title='Pick a location'
           src='/images/pick.svg'>
    `;
    listenToEvent(
      this.pickButton,
      'click',
      () => (this.pickMode = !this.pickMode)
    );
  }

  static properties = {
    type: {
      attribute: true,
    },
  };

  get pickMode() {
    return this.#pickMode;
  }

  set pickMode(v) {
    if (this.#pickMode == v) {
      return;
    }

    this.#pickMode = v;
    if (this.#pickMode) {
      this.pickButton.setAttribute('pressed', true);
    } else {
      this.pickButton.removeAttribute('pressed');
    }

    this.map.activePickControl = (this.#pickMode && this) || null;
  }

  pickLocation(loc) {
    this.value = loc.name;
    this.scheduleItemsUpdate();
    this.pickMode = false;

    this.dispatchEvent(
      new Event('valuechange', {
        bubbles: true,
      })
    );
  }

  get datavalue() {
    return super.selectedData;
  }

  set datavalue(v) {
    super.value = v.name;
    this.pickMode = false;
    this.scheduleItemsUpdate().then(() => {
      this.selectedIndex = this.itemsData.findIndex(e => e.id == v.id);
    });
  }

  onFocus(ev) {
    super.onFocus(ev);
    this.pickMode = false;
  }

  get searchOptions() {
    return {
      provider: 'camperaid',
      type: this.type,
    };
  }

  static selectors = {
    PickButton: '.pick-button',
  };

  static get elements() {
    return {
      pickButton: this.selectors.PickButton,
    };
  }

  #pickMode;
}

window.customElements.define('pick-loc-control', PickLocControl);

export { PickLocControl };
